<template>
  <div v-if="analise" class="analiseCadastral">
    <a class="fechar" @click="hide">Fechar janela</a>
    <div class="titulo">Análise Cadastral</div>
    <div class="bloqueioSugerido">
      Bloqueio sugerido: <a v-if="analise.bloqueioSugerido" class="btn btn-danger">Sim</a> <a v-else class="btn btn-success">Não existe sugestão de bloqueio</a>
    </div>

    <div class="cadastrosRelacionados">
      <div class="telefones m-t">
        <div class="font-bold">Telefones iguais</div>
        <div class="lista" v-for="(telefone, i) in analise.telefonesIguais" :key="i">
          <div class="item">
            Arrematante <a :href="'/#/website/arrematantes/'+telefone.arrematante.id" target="_blank" class="text-info font-bold">{{telefone.arrematante.apelido}}</a> com status
            <analise-a-status :arrematante="telefone.arrematante" />
            tem o mesmo telefone: {{telefone.telefone}}
          </div>
        </div>
        <div v-if="!analise.telefonesIguais || !analise.telefonesIguais.length">Nenhum registro encontrado</div>
      </div>

      <div class="enderecos m-t">
        <div class="font-bold">Endereços iguais</div>
        <div class="lista" v-for="(endereco, i) in analise.enderecosIguais" :key="i">
          <div class="item">
            Arrematante <a :href="'/#/website/arrematantes/'+endereco.arrematante.id" target="_blank" class="text-info font-bold">{{endereco.arrematante.apelido}}</a> com status
            <analise-a-status :arrematante="endereco.arrematante" />
            tem o mesmo endereço: {{endereco.endereco}}
          </div>
        </div>
        <div v-if="!analise.enderecosIguais || !analise.enderecosIguais.length">Nenhum registro encontrado</div>
      </div>

      <div class="dadosParecidos m-t">
        <div class="font-bold">Outros arrematantes com dados parecidos</div>
        <div class="lista" v-for="(dado, i) in analise.dadosParecidos" :key="i">
          <div class="item">Arrematante <a :href="'/#/website/arrematantes/'+dado.arrematante.id" target="_blank" class="text-info font-bold">{{dado.arrematante.apelido}}</a> com status
            <analise-a-status :arrematante="dado.arrematante" /> tem dados parecidos.
          </div>
        </div>
        <div v-if="!analise.dadosParecidos || !analise.dadosParecidos.length">Nenhum registro encontrado</div>
      </div>
    </div>
  </div>
</template>

<script>
import AnaliseAStatus from './AnaliseAStatus'
export default {
  name: 'AnaliseCadastral',
  components: {AnaliseAStatus},
  data () {
    return {
      analise: null,
      opened: false
    }
  },
  methods: {
    show (analise) {
      this.analise = analise.analise ? analise.analise : analise
      this.opened = true
    },
    hide () {
      this.opened = false
      this.analise = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .analiseCadastral {
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
    display: block;
    background-color: #FFFFFF;
    -webkit-box-shadow: 0px 0px 22px 0px rgba(50, 50, 50, 0.75);
    -moz-box-shadow: 0px 0px 22px 0px rgba(50, 50, 50, 0.75);
    box-shadow: 0px 0px 22px 0px rgba(50, 50, 50, 0.75);
    z-index: 2000;
    padding: 40px;
    border-radius: 6px;
    overflow: auto;
    max-height: 50%;

    .fechar{
      position: absolute;
      right: 40px;
      top: 20px;
      background-color: #000000;
      color: #FFFFFF;
      padding: 10px;
    }

    .titulo{
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// AnaliseCadastral.vue?9c65cc34